import type { LatLng, PointProperties } from '@/api/modules/delivery/types'

/**
 * Рассчет дистанции по формуле [haversine]
 * @param from - координаты точки откуда
 * @param to - координаты точки докуда
 * @return - возращаем расстояние от точки, до точки
 */
export const getDistanceBetweenPoints = (from: LatLng, to: LatLng): number => {
  const R = 6371e3 // радиус
  const f1 = (from[0] * Math.PI) / 180 // - широта
  const f2 = (to[0] * Math.PI) / 180
  const deltaF = ((to[0] - from[0]) * Math.PI) / 180 // долгота
  const deltaLambda = ((to[1] - from[1]) * Math.PI) / 180

  const a =
    Math.sin(deltaF / 2) * Math.sin(deltaF / 2) +
    Math.cos(f1) *
      Math.cos(f2) *
      Math.sin(deltaLambda / 2) *
      Math.sin(deltaLambda / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return R * c
}

/**
 * Фильтрация точек ресторана по тегам
 * @param points - точки ресторна
 * @param tags - фильтры ресторанов
 */
export const filterPointsByTags = (
  points: PointProperties[],
  tags: string[],
): PointProperties[] => {
  if (points.length === 0) return points

  const filteredPoints = points.filter((point) => {
    if (!tags.length) return true

    const pointTags = point.tags.map(({ slug }) => slug)

    for (const tag of tags) {
      if (!pointTags.includes(tag)) return false
    }

    return true
  })

  return filteredPoints
}
